// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import UploadedImageController from "./uploaded_image_controller"
application.register("uploaded-image", UploadedImageController)
